import React, { useEffect } from 'react';
import { useWebView } from '@mp';
import { Box, CircularProgress, HStack } from '@medely/ui-kit';
import { ReferralContainer } from '../referrals/ReferralContainer';

declare global {
  interface Window {
    impactToken?: string;
  }
}

const ReferralWidget = () => {
  const { setIsWebView } = useWebView();
  const hasToken = window.impactToken;

  useEffect(() => {
    setIsWebView(true);
  }, []);

  if (!hasToken) {
    return (
      <HStack justifyContent="center" alignItems="center">
        <CircularProgress />
      </HStack>
    );
  }

  return (
    <Box p={1}>
      <ReferralContainer />
    </Box>
  );
};

export default ReferralWidget;
